<template>
  <iText
    v-if="joinedAtMs"
    font-size="small"
    variant="subtle"
    data-test="call-elapsed-timer"
    role="timer"
    aria-live="off"
    :aria-label="`In this call for ${spokenElapsed}`"
  >
    {{ elapsed }}
  </iText>
</template>

<script>
const TICK_MS = 1000;
const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;

// aria-live="off" deliberately: a timer that announces itself every second
// makes a screen reader unusable; the label is there for anyone who asks.
export default {
  name: "CallElapsedTimer",
  props: {
    joinedAtMs: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      nowMs: Date.now(),
      intervalId: null,
    };
  },
  computed: {
    elapsedSeconds() {
      if (!this.joinedAtMs) {
        return 0;
      }

      return Math.max(0, Math.floor((this.nowMs - this.joinedAtMs) / 1000));
    },
    elapsed() {
      const total = this.elapsedSeconds;
      const hours = Math.floor(total / SECONDS_PER_HOUR);
      const minutes = Math.floor(total % SECONDS_PER_HOUR / SECONDS_PER_MINUTE);
      const seconds = total % SECONDS_PER_MINUTE;
      const pad = value => String(value).padStart(2, "0");

      if (hours > 0) {
        return `${hours}:${pad(minutes)}:${pad(seconds)}`;
      }

      return `${pad(minutes)}:${pad(seconds)}`;
    },
    spokenElapsed() {
      const total = this.elapsedSeconds;
      const minutes = Math.floor(total / SECONDS_PER_MINUTE);
      if (minutes < 1) {
        return "less than a minute";
      }

      return minutes === 1 ? "1 minute" : `${minutes} minutes`;
    },
  },
  watch: {
    joinedAtMs() {
      this.nowMs = Date.now();
      this.startTicking();
    },
  },
  mounted() {
    this.startTicking();
  },
  unmounted() {
    this.stopTicking();
  },
  methods: {
    startTicking() {
      if (this.intervalId !== null) {
        return;
      }
      this.intervalId = window.setInterval(() => {
        this.nowMs = Date.now();
      }, TICK_MS);
    },
    stopTicking() {
      if (this.intervalId === null) {
        return;
      }
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    },
  },
};
</script>
